import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Button } from '@/components/ui/button';
    import {
        Dialog,
        DialogContent,
        DialogHeader,
        DialogTitle,
        DialogClose,
        DialogFooter,
        DialogDescription,
        DialogBody,
    } from '@/components/ui/dialog';
    import { computed, ref } from 'vue';
    import { useI18n } from 'vue-i18n';
    import type { Payslip, AuthUser } from '@/types';
    import { toast } from 'vue-sonner';
    import { useForm } from '@inertiajs/vue3';
    import { InputRow } from '@/components/ui/form';
    import { Textarea } from '@/components/ui/textarea';
    import { useDateFormat } from '@/composables/useDateFormat';
    import QueryKey from '@/enums/QueryKey';
    import { useQueryClient } from '@tanstack/vue-query';
    import { useMutation } from '@tanstack/vue-query';
    import axios from 'axios';
    import { Alert } from '../ui/alert';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PayslipReject',
  props: {
    payslip: {},
    modelValue: { type: Boolean },
    user: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const { formatDMYFromIso } = useDateFormat();

    const queryClient = useQueryClient();

    const props = __props;

    const emit = __emit;

    const open = computed({
        get: () => props.modelValue ?? false,
        set: (value) => emit('update:modelValue', value),
    });

    const { t } = useI18n();

    const form = useForm({
        id: props.payslip.id,
        comment: '',
    });

    const rejectPayslip = () => {
        form.post(route('v2.salary.payslip.reject'), {
            preserveScroll: true,
            onSuccess: () => {
                form.resetAndClearErrors();
                toast.success(t('salary.pay_slips.reject.success'));
                queryClient.invalidateQueries({
                    queryKey: [QueryKey.PAYROLLS, props.user.selected_company_id],
                });
                handleClose();
            },
            onError: (error: any) => {
                toast.error(t('salary.pay_slips.reject.error'));
            },
        });
    };

    const handleClose = () => {
        open.value = false;
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: open.value,
    "onUpdate:open": _cache[1] || (_cache[1] = (value) => (open.value = value))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), { class: "sm:max-w-lg" }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            class: "flex max-h-full flex-col overflow-hidden",
            onSubmit: _withModifiers(rejectPayslip, ["prevent"])
          }, [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('salary.pay_slips.reject.header')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(DialogBody), { class: "space-y-5" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Alert), { variant: "warning" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('salary.pay_slips.reject.alert')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(InputRow), {
                  form: _unref(form),
                  name: "comment",
                  label: "salary.sheets.comment"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Textarea), {
                      id: "comment",
                      modelValue: _unref(form).comment,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).comment) = $event)),
                      placeholder: _unref(t)('pay-slips.comment')
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["form"])
              ]),
              _: 1
            }),
            _createVNode(_unref(DialogFooter), { class: "gap-2 border-t sm:justify-center" }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogClose), { "as-child": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      variant: "outline",
                      size: "sm",
                      onClick: handleClose
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('forms.close')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  variant: "destructive",
                  disabled: _unref(form).processing,
                  loading: _unref(form).processing,
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('pay-slips.reject')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ]),
              _: 1
            })
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})